export default [
  {
    path: 'metadata/import',
    name: 'artist-metadata-import',
    component: () => import(
      /* webpackChunkName: "artist-metadata-import" */
      '@/views/artist/metadata/MetadataImport.vue'
    ),
    children: [
      {
        path: '',
        name: 'artist-metadata-import-type',
        meta: {
          title: 'nav.metadata_import',
        },
        component: () => import(
          /* webpackChunkName: "artist-metadata-import-type" */
          '@/views/artist/metadata/steps/ImportType.vue'
        ),
      },
      {
        path: 'upload',
        name: 'artist-metadata-import-upload',
        meta: {
          title: 'nav.metadata_import',
        },
        component: () => import(
          /* webpackChunkName: "artist-metadata-import-upload" */
          '@/views/artist/metadata/steps/ImportUpload.vue'
        ),
      },
      {
        path: 'match/:id',
        // name: 'artist-metadata-import-match',
        component: () => import(
          /* webpackChunkName: "artist-metadata-import-match-wrapper" */
          '@/views/artist/metadata/steps/ImportMatchWrapper.vue'
        ),
        children: [
          {
            path: '',
            name: 'artist-metadata-import-match',
            meta: {
              title: 'nav.metadata_import',
            },
            component: () => import(
              /* webpackChunkName: "artist-metadata-import-match" */
              '@/views/artist/metadata/steps/ImportMatch.vue'
            ),
          },
          {
            path: 'category',
            name: 'artist-metadata-import-match-category',
            meta: {
              title: 'nav.metadata_import',
            },
            component: () => import(
              /* webpackChunkName: "artist-metadata-import-match-category" */
              '@/views/artist/metadata/steps/ImportMatchCategory.vue'
            ),
          },
          {
            path: 'publisher',
            name: 'artist-metadata-import-match-publisher',
            meta: {
              title: 'nav.metadata_import',
            },
            component: () => import(
              /* webpackChunkName: "artist-metadata-import-match-publisher" */
              '@/views/artist/metadata/steps/optional/ImportMatchPublisher.vue'
            ),
          },
          {
            path: 'composer',
            name: 'artist-metadata-import-match-composer',
            meta: {
              title: 'nav.metadata_import',
            },
            component: () => import(
              /* webpackChunkName: "artist-metadata-import-match-composer" */
              '@/views/artist/metadata/steps/optional/ImportMatchComposer.vue'
            ),
          },
          {
            path: 'arranger',
            name: 'artist-metadata-import-match-arranger',
            meta: {
              title: 'nav.metadata_import',
            },
            component: () => import(
              /* webpackChunkName: "artist-metadata-import-match-arranger" */
              '@/views/artist/metadata/steps/optional/ImportMatchArranger.vue'
            ),
          },
          {
            path: 'performer',
            name: 'artist-metadata-import-match-performer',
            meta: {
              title: 'nav.metadata_import',
            },
            component: () => import(
              /* webpackChunkName: "artist-metadata-import-match-performer" */
              '@/views/artist/metadata/steps/optional/ImportMatchPerformer.vue'
            ),
          },
          {
            path: 'model-release',
            name: 'artist-metadata-import-match-release-model',
            meta: {
              title: 'nav.metadata_import',
            },
            component: () => import(
              /* webpackChunkName: "artist-metadata-import-match-release-model" */
              '@/views/artist/metadata/steps/optional/ImportMatchReleaseModel.vue'
            ),
          },
          {
            path: 'property-release',
            name: 'artist-metadata-import-match-release-property',
            meta: {
              title: 'nav.metadata_import',
            },
            component: () => import(
              /* webpackChunkName: "artist-metadata-import-match-release-property" */
              '@/views/artist/metadata/steps/optional/ImportMatchReleaseProperty.vue'
            ),
          },
        ],
      },
      {
        path: 'tag/:id',
        name: 'artist-metadata-import-tag',
        meta: {
          title: 'nav.metadata_import',
        },
        component: () => import(
          /* webpackChunkName: "artist-metadata-import-tag" */
          '@/views/artist/metadata/steps/ImportTag.vue'
        ),
      },
      {
        path: 'review/:id',
        name: 'artist-metadata-import-review',
        meta: {
          title: 'nav.metadata_import',
        },
        component: () => import(
          /* webpackChunkName: "artist-metadata-import-review" */
          '@/views/artist/metadata/steps/ImportReview.vue'
        ),
      },
      {
        path: 'progress/:id',
        name: 'artist-metadata-import-progress',
        meta: {
          title: 'nav.metadata_import',
        },
        component: () => import(
          /* webpackChunkName: "artist-metadata-import-progress" */
          '@/views/artist/metadata/steps/progress/ImportProgress.vue'
        ),
      },
    ],
  },
  // {
  //   path: 'metadata/specs',
  //   name: 'artist-metadata-specs-list',
  //   component: () => import(
  //     /* webpackChunkName: "artist-metadata-specs-list" */
  //     '@/views/artist/metadata-specs/MetadataSpecsList.vue.bk'
  //   ),
  // },
  {
    path: 'metadata/specs/:mediaType',
    name: 'artist-metadata-spec-by-media-type',
    meta: {
      title: 'nav.metadata_import',
    },
    component: () => import(
      /* webpackChunkName: "artist-metadata-spec-by-media-type" */
      '@/views/artist/metadata-specs/MetadataSpecByMediaType.vue'
    ),
  },
];
